import { FeatureTabsAccordionNoContent } from '@/components/Shared/FeatureTabsAccordionNoContent';
import { FeatureTabsDesktopNoContent } from '@/components/Shared/FeatureTabsDesktopNoContent';
import { FormattedText } from '@/components/Shared/FormattedText';
import { Container } from '@/components/Shared/Layout/Container';
import { SbSection } from '@/components/Shared/Layout/SbSection';
import { isArrayWithValue } from '@/utils/helpers/isArrayWithValue';
import { IFeatureTabsNoContent } from '@/utils/interfaces/bloks';
import { Fragment } from 'react';

interface IProps {
  blok: IFeatureTabsNoContent;
  preview: boolean;
}

export const FeatureTabsNoContent: React.FC<IProps> = ({ blok, preview }) => {
  return (
    <SbSection
      blok={blok}
      preview={preview}
      classNames="relative bg-white pt-[42px] md:py-[70px]"
    >
      <Container align="center">
        <div className="mb-10">
          <div className="mb-5 md:text-7xl sm:text-4xl text-3xl max-w-[1080px] mx-auto">
            <FormattedText tag="h2" text={blok.heading} />
          </div>
          <p className='text-[20px] font-medium'>{blok.sub_heading}</p>
        </div>

        {isArrayWithValue(blok.tabs) && (
          <Fragment>
            <ul className="block md:hidden">
              <FeatureTabsAccordionNoContent
                cta={blok.view_all_cta}
                ctaLabel={blok.cta_label}
                tabs={blok.tabs}
              />
            </ul>

            <div className="hidden md:block">
              <FeatureTabsDesktopNoContent
                tabs={blok.tabs}
                cta={blok.view_all_cta}
                ctaLabel={blok.cta_label}
                preview={preview}
              />
            </div>
          </Fragment>
        )}
      </Container>
    </SbSection>
  );
};
